function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#app-logo_inline_svg__clip0_2178_2593)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#app-logo_inline_svg__filter0_d_2178_2593)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 52,
  height: 52,
  rx: 9,
  fill: "#ADC6CA"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.524 19c.088.162.132.358.213.533.308.732.83 1.397 1.391 2.005-.155.27-.41.489-.587.75a4.81 4.81 0 00-.903 3.919c.237 1.29.714 2.507 1.54 3.588.045-2.21.795-4.156 2.433-5.544.498-.355 1-.699 1.582-.8l.275.515c.287.507.612.992.97 1.45a.11.11 0 01.002.096.107.107 0 01-.073.06c-1.56-.04-3.115 1.205-3.673 2.648-.24.6-.365 1.242-.367 1.89.021.062.079.02.109.007l4.083-2.698c.206-.948.907-1.91 1.868-2.209.96-.3 2.103-.055 2.724.803.157.212.288.442.39.686l-.089.136-1.965 1.745c-.004.077.094.057.144.08a1.53 1.53 0 001.154-.191l4.096-3.61.77-.686c.182 0 .313.155.46.246.59.472.984 1.156 1.1 1.913a.09.09 0 00.06.038.088.088 0 00.067-.018c.834-.561 1.65-1.177 2.48-1.748.054-.165.062-.346.115-.51 1.072-1.03 2.457-1.591 3.91-1.2a2.514 2.514 0 011.535 1.65c.032.045.083.011.12 0l1.523-.965c.238-.192.298-.48.495-.705.727-.99 1.888-1.5 3.067-1.2.401.084.753.275 1.1.474.123-.144.037-.442.28-.481.63 0 1.27.026 1.887-.017l.016.052-.35 1.581a.787.787 0 00.368.715c.147.12.357.12.54.09.159-.044.295-.182.426-.288.343.192.673.405 1.01.608.234-.029.48-.019.692-.112l.049.014c.11.249.258.478.44.68l-.075.066-3.307.625-4.687.952-8.005 1.598-.056.077-.176.976-.072.034c-.564.11-1.128.232-1.698.326.005-.27.102-.5.1-.74l-.006-.105c-.902.096-1.756.297-2.62.462l-5.764 1.169L6.65 33c-.054-.022-.01-.083.008-.111.386-.408.666-.907.815-1.453.572-.139 1.174-.248 1.76-.37.18-.046.366-.058.536-.135-2.062-2.048-3.608-4.436-3.76-7.204-.094-1.695.564-3.084 1.715-4.186.236-.224.506-.407.8-.541zm4.119 11.395l3.96-.782.153-.05c-.235-.181-.507-.345-.714-.587-.194-.163-.249-.488-.52-.514l-2.88 1.933zm10.606-3.804l-2.502 2.203-.036.09c.72-.132 1.446-.25 2.151-.425-.042-.099-.14-.198-.177-.307-.09-.487.491-.315.68-.64a.759.759 0 00.134-.66l-.141-.253a.138.138 0 00-.109-.008zm-4.872.431a.98.98 0 00-1.08.42.98.98 0 00-.048.697.288.288 0 00.14.152l1.221-1.038.014-.058c-.074-.07-.134-.172-.247-.172zm8.274.055c-.154.12-.337.177-.47.321a2.81 2.81 0 00-.213.493 44.973 44.973 0 002.293-.455c.159-.479.192-1.034.265-1.542l-.052-.002-1.823 1.185zm3.565-.525c-.084.143-.082.33-.123.498l.046.053.742-.13.053-.046a1.59 1.59 0 01-.668-.372l-.05-.003zm5.76-1.99c-.03-.004-.048.01-.07.017l-1.933 1.302c-.047.22-.225.372-.319.576l3.13-.648a1.613 1.613 0 01-.807-1.248l-.001.002zm-4.27-.127c-.269-.18-.689-.201-.953 0-.262.233-.273.655-.154.96.138.32.424.547.761.603a.734.734 0 00.685-.288.863.863 0 00.102-.689l-.034-.098v.002a1.094 1.094 0 00-.408-.49zm8.888.486c-.021.085-.135.13-.114.226.274-.046.556-.093.782-.207-.221-.02-.339-.252-.538-.314l-.13.295zm.668.02h.005v-.002l-.005.001zm-2.549-1.645a.716.716 0 00-.802.115c-.175.17-.211.486-.128.71.059.268.319.492.564.568a.687.687 0 00.697-.173.77.77 0 00.094-.774l-.001.002a.939.939 0 00-.424-.448z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "app-logo_inline_svg__clip0_2178_2593"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h52v52H0z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "app-logo_inline_svg__filter0_d_2178_2593",
  x: -4,
  y: -3,
  width: 60,
  height: 60,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2178_2593"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2178_2593",
  result: "shape"
})));

function SvgAppLogoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgAppLogoinline;